import { useStarterDashboardPageFcmExperiments } from 'src/app/pages/starterDashboard/pageContext';

type UseStarterDashboardTabExperiment = ModelHookResult<{
	variant: string;
	isSecondVariant: boolean;
}>;

export function useStarterDashboardTabExperiment(): UseStarterDashboardTabExperiment {
	const { dashboardTabsExperiment } = useStarterDashboardPageFcmExperiments();

	return {
		data: {
			variant: dashboardTabsExperiment.variation,
			isSecondVariant: dashboardTabsExperiment.variation === 'variant2',
		},
	};
}
